import styled from 'styled-components';

import { config } from 'config';
const color = config.theme?.header?.color ? config.theme.header.color : '#e6eaec';

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  div {
    color: ${color};
    font-size: 13px;
    font-weight: 500;
    /* margin-left: 0px; */
    /* margin-right: 0px; */
  }
  img {
    cursor: pointer;
  }
  &:hover .menu11 {
    display: block;
  }
`;

export const Button = styled.button`
  height: 34px;
  line-height: 32px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #e6eaec;
  border-radius: 10px;
  padding: 0 15px 0px 35px;
  background: #141c18 url('/images/settings.svg') no-repeat 11px 50%;
  background-size: 18px;
  border: 1px solid #3d4952;
  cursor: pointer;
  margin: 0 5px 0 0;
  position: relative;
  outline: none;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
  &:hover {
    border-color: #47b972;
    color: #5cc98a;
    background-color: #1a2429;
  }
  &:focus-visible {
    border-color: #47b972;
    color: #5cc98a;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.16);
  }
  .menu1 {
    position: absolute;
    display: none;
    right: 0;
    top: 34px;
    z-index: 99999;
    padding-top: 7px;
  }
  .menu1items {
    background: #161e23;
    border: 1px solid #3d4952;
    border-radius: 10px;
    white-space: nowrap;
    min-width: 250px;
    display: block;
    overflow: hidden;
    box-shadow: 0 14px 40px rgba(0, 0, 0, 0.35);
  }
  &:hover {
    .menu1 {
      display: block;
    }
  }
  &.menu-closed .menu1 {
    display: none;
  }
`;

export const Subbutton = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* единая высота пунктов меню «Настройки» (то же значение в widgets-menu.styled.js) */
  height: 36px;
  box-sizing: border-box;
  line-height: 1.3;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #e6eaec;

  padding: 0 15px;
  background: #161e23;
  border: 0;
  text-align: right;
  cursor: pointer;
  margin: 0;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  &.sb-input {
    display: flex;
    align-items: center;
    line-height: normal;
    justify-content: flex-end;
  }
  &.sb-sub {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-right: 26px;
    font-size: 12px;
    color: #aab2b8;
  }
  &:hover {
    background: #232e35;
    color: #5cc98a;
  }
  input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    box-sizing: border-box;
    width: 17px;
    height: 17px;
    flex-shrink: 0;
    margin: 0 10px 0 0;
    border: 1px solid #3d4952;
    border-radius: 5px;
    background: #10151a;
    cursor: pointer;
    transition:
      background 0.15s ease,
      border-color 0.15s ease;
    &:checked {
      background-color: #47b972;
      border-color: #47b972;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 11px;
    }
  }
`;

export const LogoutButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;

  color: #e6eaec;
  border-radius: 10px;
  padding: 0 14px;
  border: 1px solid #3d4952;

  background: #141c18;
  background-image: none;
  &:hover {
    border-color: #47b972;
    color: #5cc98a;
    background-color: #1a2429;
  }
`;

export const UserName = styled.div`
  margin-left: 20px;
  margin-right: 10px;
`;
